/* Imports */
import React from "react"
import { Toast } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const ToastPage = () => {
    const items = [
        {
            title: "Without close button",
            content: (
                <Toast title="Title" icon="check-circle-solid">
                    Content
                </Toast>
            ),
            code: '<Toast title="Title" icon="check-circle-solid">\n    Content\n</Toast>',
        },
        {
            title: "With close button",
            content: (
                <Toast title="Title" fajnyIcon="close-circle-solid" iconColor="danger" close>
                    Content
                </Toast>
            ),
            code: '<Toast title="Title" fajnyIcon="close-circle-solid" iconColor="danger" close>\n    Content\n</Toast>',
        },
    ]

    const propsItems = [
        {
            name: "title",
            type: "String",
            example: "You have a new message!",
            required: "Yes",
        },
        {
            name: "close",
            type: "Boolean",
        },
        {
            name: "icon",
            type: "String",
            example: "check",
        },
        {
            name: "fajnyIcon",
            type: "String",
            example: "check-solid",
            possible: commonProps.fajnyIcons,
        },
        {
            name: "iconColor",
            type: "String",
            example: "success-400",
            possible: commonProps.allColors,
            default: "primary",
        },
        {
            name: "iconClose",
            type: "String",
            example: "close",
        },
        {
            name: "fajnyIconClose",
            type: "String",
            example: "close-regular",
            possible: commonProps.fajnyIcons,
            default: "close-solid",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default ToastPage
